import React from 'react';
import { AuthProvider } from './auth';
import { OAuthProvider } from './oauth';

interface IProps {
  children: React.ReactNode;
}

const AppProvider: React.FC<IProps> = ({ children }) => (
  <OAuthProvider>
    <AuthProvider>
      {children}
    </AuthProvider>
  </OAuthProvider>
);

export default AppProvider;
